/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cockpit_Stat_Returns_ValueInputs */

const tr_landing_cockpit_stat_returns_value = /** @type {(inputs: Landing_Cockpit_Stat_Returns_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`%2,1`)
};

const en_landing_cockpit_stat_returns_value = /** @type {(inputs: Landing_Cockpit_Stat_Returns_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2.1%`)
};

const de_landing_cockpit_stat_returns_value = /** @type {(inputs: Landing_Cockpit_Stat_Returns_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2,1 %`)
};

const ru_landing_cockpit_stat_returns_value = /** @type {(inputs: Landing_Cockpit_Stat_Returns_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2,1 %`)
};

/**
* | output |
* | --- |
* | "2.1%" |
*
* @param {Landing_Cockpit_Stat_Returns_ValueInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_cockpit_stat_returns_value = /** @type {((inputs?: Landing_Cockpit_Stat_Returns_ValueInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cockpit_Stat_Returns_ValueInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_cockpit_stat_returns_value(inputs)
	if (locale === "de") return de_landing_cockpit_stat_returns_value(inputs)
	if (locale === "ru") return ru_landing_cockpit_stat_returns_value(inputs)
	return tr_landing_cockpit_stat_returns_value(inputs)
});